import React, { useState, useRef } from 'react';

const ComplianceGrade = ({ type }) => {
	const [isShowInfo, setIsShowInfo] = useState(false);
	const rulesRef = useRef(null);

	const renderSupplierGrade = () => {
		return (
			<div
				className={`common-popup supplier-grade-modal shadow-8dp scroll-x-label ${
					type === 'GRADE' ? 'strength-modal suppplier-rank' : ''
				}`}
				ref={rulesRef}
			>
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0 text-capitalize">
							{type === 'CERTIFICATE_STRENGTH' ? 'Compliance grade matrix' : 'Supplier rank'}
						</h3>
					</div>
					<div className="close-btn" onClick={() => setIsShowInfo(false)}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					{type === 'CERTIFICATE_STRENGTH' ? (
						<table className="table with-border hover">
							<thead>
								<tr>
									<th className="weight-500 text-capitalize">Grade</th>
									<th className="weight-500 text-capitalize">Social &amp; Environmental</th>
									<th className="weight-500 text-capitalize">Security</th>
									<th className="weight-500 text-capitalize">Sustainability</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="weight-600">5</td>
									<td>BSCI, SEDEX, HIGG FEM,BETTER WORK</td>
									<td>WRAP or SECURITY or SCAN or GSV or CT-PAT</td>
									<td>BCI, OCS, RCS, GRS,GOTS, OEKO-TEX</td>
								</tr>
								<tr>
									<td className="weight-600">4</td>
									<td>BSCI, SEDEX</td>
									<td>WRAP or CT-PAT</td>
									<td>OCS, RCS, GOTS, OEKO-TEX</td>
								</tr>
								<tr>
									<td className="weight-600">3</td>
									<td>BSCI</td>
									<td>WRAP or CT-PAT</td>
									<td>OEKO-TEX</td>
								</tr>
								<tr>
									<td className="weight-600">2</td>
									<td>BSCI</td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					) : (
						<div className="rank-details">
							<p className="regular-14 gray_dark_02">
								Our suppliers were ranked based on their performance.
							</p>
							<p className="regular-14 gray_dark_02">
								Ranked as follows:
								<span className="regular-14 gray_dark_02 weight-600">
									{' '}
									A - Excellent, B - Above Average, C - Acceptable, and D - Poor.
								</span>
							</p>
							<p className="regular-14 gray_dark_02 mt-3 mb-1">This is based on:</p>
							<ul>
								<li className="regular-14 gray_dark_02 weight-400"> Order delivery - 45%</li>
								<li className="regular-14 gray_dark_02 weight-400">
									{' '}
									Compliance Grade - 25%
								</li>
								<li className="regular-14 gray_dark_02 weight-400">Team feedback - 15%</li>
								<li className="regular-14 gray_dark_02 weight-400">Supplier status - 10 %</li>
								<li className="regular-14 gray_dark_02 weight-400"> Quality hit rate - 5%</li>
							</ul>
						</div>
					)}
				</div>
			</div>
		);
	};

	return (
		<div className="supplier-info-btn position-relative">
			<button className="border-0 bg-transparent" onClick={() => setIsShowInfo(true)}>
				<img src={`${process.env.PUBLIC_URL}/icons/info.svg`} alt="info" />
			</button>
			{isShowInfo && renderSupplierGrade()}
		</div>
	);
};

export default ComplianceGrade;
